import React, { useState } from 'react';
import Modal from 'react-modal';
import RenderField from './Render';
import '../styles/_previewModal.scss';

const PreviewModal = ({ isOpen, toggleModal, formFields }) => {
    const [shortcodeVisible, setShortcodeVisible] = useState(false);
    const shortcode = '[simple_form id="form id"]'

    const handleFormSubmit = (e) => {
        e.preventDefault();
        setShortcodeVisible(true);
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={toggleModal}
            contentLabel="Preview Form Modal"
            className="preview-modal"
            overlayClassName="preview-modal-overlay"
            ariaHideApp={false}
        >
            <div className="modal-header">
                <h2>Preview Form</h2>
                <button className="close-modal-button" onClick={toggleModal}>
                    &times;
                </button>
            </div>
            <div className="modal-body">
                <form className="preview-form" onSubmit={handleFormSubmit}>
                    {formFields.map((field) => (
                        <RenderField key={field.uniqueId} field={field} />
                    ))}

                    {/* Submit button */}
                    <button
                        type="submit"
                        className="submit-button sf-form-submit"
                    >
                        Submit
                    </button>
                </form>

                {/* Show shortcode after form submission */}
                {shortcodeVisible && (
                    <div className="shortcode-display">
                        <p>Copy the shortcode below to embed the form on your page:</p>
                        <div className="shortcode-box">
                            <code>{shortcode}</code>
                            <button
                                className="copy-shortcode-button"
                                onClick={() => navigator.clipboard.writeText(shortcode)}
                            >
                                Copy Shortcode
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default PreviewModal;
